import { RouteObject } from "react-router";

import * as Sentry from "@sentry/react";

import PageError from "@/helpers/components/Errors/PageError";

export const CompetencyRoutes: RouteObject = {
	path: "competency/*",
	children: [
		{
			path: "user/*",
			lazy: async () => {
				const { UserCompetency } = await import(
					"@/components/Competency/UserCompetency"
				);
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={({ error, componentStack, resetError }) => (
								<PageError
									error={error}
									componentStack={componentStack}
									reset={resetError}
								/>
							)}
						>
							<UserCompetency />
						</Sentry.ErrorBoundary>
					),
				};
			},
			children: [
				{
					path: ":userid",
					lazy: async () => {
						const { UserCompetency } = await import(
							"@/components/Competency/UserCompetency"
						);
						return { Component: UserCompetency };
					},
				},
			],
		},
		{
			path: "resource/*",
			children: [
				{
					path: "new",
					lazy: async () => {
						const { NewCompetencyResource } = await import(
							"@/components/Competency/CompetencyResource"
						);
						return { Component: NewCompetencyResource };
					},
				},
				{
					path: ":id/edit",
					lazy: async () => {
						const { EditCompetencyResource } = await import(
							"@/components/Competency/CompetencyResource"
						);
						return { Component: EditCompetencyResource };
					},
				},
				{
					path: ":id/delete",
					lazy: async () => {
						const { DeleteCompetencyResource } = await import(
							"@/components/Competency/CompetencyResource"
						);
						return { Component: DeleteCompetencyResource };
					},
				},
			],
		},
		{
			path: "matrix/*",
			children: [
				{
					index: true,
					lazy: async () => {
						const { ShowCompetenceMatrix } = await import(
							"@/components/Competency/ShowCompetenceMatrix"
						);
						return { Component: ShowCompetenceMatrix };
					},
				},
				{
					path: "id",
					lazy: async () => {
						const { ShowCompetenceMatrix } = await import(
							"@/components/Competency/ShowCompetenceMatrix"
						);
						return { Component: ShowCompetenceMatrix };
					},
				},
			],
		},
		{
			path: "create/:id/user/:userid",
			lazy: async () => {
				const { CreateCompetency } = await import(
					"@/components/Competency/CreateCompetency"
				);
				return { Component: CreateCompetency };
			},
		},
		{
			path: "checkoff/:id",
			lazy: async () => {
				const { CompetencyCheckoff } = await import(
					"@/components/Competency/CompetencyCheckoff"
				);
				return { Component: CompetencyCheckoff };
			},
		},
	],
};
